export const getDefaultParticleDistributionSettings = (settingName: string): Array<[number, number, string]> => {
  if (`${settingName || ''}`.startsWith('particle_distribution_2')) {
    return [
      [0, 1, 'Range 1'],
      [1, 2, 'Range 2'],
      [2, 3, 'Range 3'],
      [3, 4, 'Range 4'],
      [4, 5, 'Range 5'],
      [5, 6, 'Range 6'],
    ];
  }

  return [
    [0, 6, 'Range 1'],
    [6, 12, 'Range 2'],
    [12, 18, 'Range 3'],
    [18, 24, 'Range 4'],
    [24, 30, 'Range 5'],
  ];
};

export const PARTICLE_DISTRIBUTION_SETTING_NAMES = [
  'particle_distribution_1',
  'particle_distribution_2',
  'particle_distribution_3',
];
